var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasolineFrontwheels2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 91,
    viewBox: "0 0 398 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 352.194,
    cy: 45.5354,
    r: 39.7674,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 10.6047
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2659,
    cy: 45.5354,
    r: 39.7674,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 10.6047
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.233,
    cy: 45.5354,
    r: 39.7674,
    fill: "#F1E29E",
    stroke: "black",
    strokeWidth: 10.6047
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3011,
    cy: 45.5354,
    r: 39.7674,
    fill: "#F1E29E",
    stroke: "black",
    strokeWidth: 10.6047
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolineFrontwheels2);
export default __webpack_public_path__ + "static/media/gasoline-frontwheels2.5f12b0dbf7aa5b2bf5d646c1dbfa4c52.svg";
export { ForwardRef as ReactComponent };